import { render, staticRenderFns } from "./LanguageSettings.vue?vue&type=template&id=2415d3a9&scoped=true&"
import script from "./LanguageSettings.vue?vue&type=script&lang=js&"
export * from "./LanguageSettings.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSettings.vue?vue&type=style&index=0&id=2415d3a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415d3a9",
  null
  
)

export default component.exports